export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_ERROR = "GET_CUSTOMER_ERROR";

export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";

